import Image from "next/image";
import { getAssetsUrl } from "utils";
import { CustomImageProps } from "./types";

const LOCAL_ASSET_REGEX = /^(?!https?:|data:|\/\/)/i;

export const AssetImage = ({
  src,
  alt = "",
  unoptimized,
  ...props
}: CustomImageProps) => {
  if (!src || src.trim() === "") {
    return null;
  }

  const srcWithBasePath = getAssetsUrl(src);
  const isLocalAsset = LOCAL_ASSET_REGEX.test(src);
  const shouldDisableOptimization = unoptimized ?? isLocalAsset;

  return (
    <Image
      src={srcWithBasePath}
      alt={alt}
      unoptimized={shouldDisableOptimization}
      {...props}
    />
  );
};

